import { Avatar } from 'src/design/atoms/Avatar';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { TextInput } from 'src/design/atoms/TextInput';
import { IconCheck, IconX } from '@tabler/icons-react';
import React from 'react';
import { TopicIssueDto } from 'src/api/FiretrolApiClient';
import { useCreateMeetingComment } from 'src/api/queries/meetings/useMeetingCommentMutations';
import { useAuth } from 'src/hooks/useAuth';

interface NewCommentProps {
  issue: TopicIssueDto | null;
  jobId: number;
}

export const NewComment: React.FC<NewCommentProps> = ({ issue, jobId }) => {
  const { user } = useAuth();
  const [value, setValue] = React.useState('');

  const createComment = useCreateMeetingComment({
    jobId,
    meetingId: issue?.meetingId ?? '',
    topicId: issue?.topicId ?? '',
    issueId: issue?.id ?? '',
  });

  const confirmComment = () => {
    if (!user || !issue) return;
    createComment.mutate(value, { onSuccess: () => setValue('') });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      confirmComment();
    }
  };

  if (!user) return null;

  return (
    <Stack gap="xs">
      <Group gap="xs" align="flex-start">
        <Avatar size="sm" color="blue">
          {user.firstName.slice(0, 1)}
        </Avatar>
        <TextInput
          placeholder="Add a comment..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{ flex: 1 }}
        />
      </Group>

      {value.length > 0 && (
        <Group gap="xs" justify="flex-end">
          <BasicActionIcon
            variant="light"
            color="red"
            onClick={() => setValue('')}
            size="sm"
          >
            <IconX size={16} />
          </BasicActionIcon>
          <BasicActionIcon
            variant="light"
            color="blue"
            onClick={confirmComment}
            loading={createComment.isPending}
            size="sm"
          >
            <IconCheck size={16} />
          </BasicActionIcon>
        </Group>
      )}
    </Stack>
  );
};
